import { render, staticRenderFns } from "./ConfigCategoriesList.vue?vue&type=template&id=6d14d08d&scoped=true&"
import script from "./ConfigCategoriesList.vue?vue&type=script&lang=js&"
export * from "./ConfigCategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCategoriesList.vue?vue&type=style&index=0&id=6d14d08d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d14d08d",
  null
  
)

export default component.exports